export interface DashBoardData {
    label: string;
    count: number;
}

export const formatAmountWithoutDots = (amountVal, defaultReturnValue = '0') => {
  if (!amountVal) return defaultReturnValue
  let amt = ''
  const amount = amountVal.toString()
  if (amount.includes('.')) {
    // remove . and take only next 2 float even if it contains more than 2 float
    // if it contains one then add ono zero
    const [integer, float] = amount.split('.')
    amt = `${parseInt(integer) ? integer : ''}${float.length > 1 ? float.substring(0, 2) : float + '0'}`
  } else if (amount == 0) {
    amt = defaultReturnValue;
  } else {
    amt = `${amount}00`
  }

  if (parseFloat(amt) <= 0) return defaultReturnValue
  return amt
}

export enum ControlCenterSendTypes{
  SEND_COMMAND="SEND_COMMAND",
  SEND_COMMUNICATION="SEND_COMMUNICATION"
}

export const identifierToJsonKey: Record<string, string> = {
  'apple pay': 'applepay',
  'tap on phone': 'tapOnphone'
};
